export default __webpack_public_path__ + "static/media/5-como-funciona.fd5425bd.png";